import { render, staticRenderFns } from "./technical_eval_dashboard.vue?vue&type=template&id=7c72bafa&scoped=true&"
import script from "./technical_eval_dashboard.vue?vue&type=script&lang=js&"
export * from "./technical_eval_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./technical_eval_dashboard.vue?vue&type=style&index=0&id=7c72bafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72bafa",
  null
  
)

export default component.exports